// Matches the bidder details at the end of a bid accept message, e.g. " (Paddle # 1000)" in "Lot 1 Bid - USD 45 (Paddle # 1000)"
export const BID_ACCEPT_MESSAGE_BIDDER_DETAILS_REGEX = / \([^)]*\)$/;
